import React from 'react';
import Navbar from "./Sections/Navbar/Navbar";
import Header from "./Sections/Hero/Header";
import ServiceSection from "./Sections/Service/Service";
import Gallery from "./Sections/Gallery/Gallery";
import Testimonials from "./Sections/Testimonial/Testimonial";
import AboutUs from "./Sections/AboutUs/About";
import FoundationSchool from './Sections/Foundation/Foundation';
import Newsletter from './Sections/Newsletter/Newsletter';

const Home = () => {
  return (
    <div>
      <Navbar />
      <div id="header">
        <Header />
      </div>
      <div id="service">
        <ServiceSection />
      </div>
      <Testimonials />
      <Gallery />
      <AboutUs />
      <div id="foundation">
        <FoundationSchool />
      </div>
      <Newsletter />
    </div>
  );
};

export default Home;
